import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

function PauseOverlay({ onResume }) {
  return (
    <motion.div
      className="absolute inset-0 z-50 flex items-center justify-center
                 bg-puzzle-background/95 backdrop-blur-md"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="text-center"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.1 }}
      >
        <h2 className="text-2xl font-bold text-puzzle-text mb-2">Paused</h2>
        <p className="text-puzzle-text-secondary mb-6">
          Your timer is stopped
        </p>
        <button
          type="button"
          onClick={onResume}
          className="px-6 py-3 bg-puzzle-blue text-white rounded-lg
                     font-medium hover:bg-blue-600 transition-colors"
        >
          Resume Puzzle
        </button>
      </motion.div>
    </motion.div>
  );
}

PauseOverlay.propTypes = {
  onResume: PropTypes.func.isRequired,
};

export default PauseOverlay;
